<template>
  <div class="inloader"></div>
</template>

<script>
import colors from '@/mixins/colors'
export default {

  mixins: [colors]
}
</script>

<style lang="scss">
.inloader {
  height: 4px;
  width: 100%;
  position: relative;
  overflow: hidden;
  background-color: #ddd;
}
.inloader:before{
  display: block;
  position: absolute;
  content: "";
  left: -200px;
  width: 200px;
  height: 4px;
  background-color: #5E2B8B;
  animation: inloading 2s linear infinite;
}

@keyframes inloading {
    from {left: -200px; width: 30%;}
    50% {width: 30%;}
    70% {width: 70%;}
    80% { left: 50%;}
    95% {left: 120%;}
    to {left: 100%;}
}
</style>
